import { ShieldAlert } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";

export default function NoAccess() {
  return (
    <div data-testid="no-access-page" className="flex items-center justify-center min-h-[60vh]">
      <Card className="card-streamcon max-w-md text-center">
        <CardContent className="p-8">
          <div className="w-16 h-16 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <ShieldAlert className="w-8 h-8 text-amber-500" />
          </div>
          <h2 className="text-xl font-heading font-bold text-foreground mb-2">
            Limited Access
          </h2>
          <p className="text-muted-foreground text-sm mb-4">
            Your current role (HR) has limited access to StreamCon modules.
            Please contact your administrator if you need additional permissions.
          </p>
          <div className="text-xs text-muted-foreground bg-muted/50 rounded-sm p-3">
            <p className="font-medium mb-1">Available Roles:</p>
            <ul className="space-y-1">
              <li>• <span className="text-crimson">Admin</span> - Full system access</li>
              <li>• <span className="text-blue-500">Engineer</span> - Projects, BOQ, Progress</li>
              <li>• <span className="text-emerald-500">Accountant</span> - Billing management</li>
              <li>• <span className="text-amber-500">HR</span> - Limited access</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
